import { BYTES_UNITS } from "../consts/units.consts"

export const imageFormatSize = (bytes, useKiloBytes = true) => {
  if (!bytes || bytes === 0) return useKiloBytes ? '0 KB' : '0 MB'

  if (useKiloBytes && bytes < BYTES_UNITS.MEGABYTE) {
    return `${(bytes / BYTES_UNITS.KILOBYTE).toFixed(2)} KB`
  }
  return `${(bytes / BYTES_UNITS.MEGABYTE).toFixed(2)} MB`
}